<template>
    <div v-show="visible">
        <el-dialog title="修改校币" :close-on-click-modal="false"
            v-loading="loading"
            :element-loading-text="loadingText"
            :visible.sync="visible" width="430px">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item prop="coinName" label="校币名称">
                    <el-input v-model="form.coinName" placeholder="请输入校币名称" style="width:280px;" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item prop="coinDenomination" label="面额(元)">
                    <el-select v-model="form.coinDenomination" placeholder="请选择面额" style="width:280px;">
                        <el-option v-for="item in denominationOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="correspondingPoints" label="对应积分">
                    <el-input-number v-model="form.correspondingPoints" :min="0" :precision="0" style="width:280px;" placeholder="请输入对应积分"></el-input-number>
                </el-form-item>
                <el-form-item prop="evaluateType" label="五育类型">
                    <el-select v-model="form.evaluateType" placeholder="请选择五育类型" style="width:280px;">
                        <el-option v-for="item in evaluateTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="校币图片">
                    <el-upload
                        class="avatar-uploader"
                        :action="uploadUrl"
                        :disabled="isUploadImage"
                        :show-file-list="false"
                        :auto-upload="true"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" :style="{transform:'rotateZ('+deg+'deg)'}" style="background-color:#d0d0d0;" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item prop="orderNum" label="排序号">
                    <el-input-number v-model="form.orderNum" :min="0" :precision="0" style="width:280px;" placeholder="排序号，数字越小越靠前"></el-input-number>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="save()">保 存</el-button>
                <el-button @click="visible=false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        name: "CoinUpdate",
        data() {
            return {
                loading: false,
                loadingText: "",
                visible: false,
                uploadUrl: "",
                imageUrl: "",
                deg: 0,
                isUploadImage: false,
                form: {
                    id: "",
                    deptId: "",
                    coinName: "",
                    coinDenomination: "",
                    correspondingPoints: 0,
                    evaluateType: "",
                    coinImageUrl: "",
                    orderNum: 0
                },
                denominationOptions: [10, 20, 50, 100],
                evaluateTypeOptions: [
                    { value: '1', label: '德育' },
                    { value: '2', label: '智育' },
                    { value: '3', label: '体育' },
                    { value: '4', label: '美育' },
                    { value: '5', label: '劳育' }
                ],
                rules: {
                    coinName: [{ required: true, message: '请输入校币名称', trigger: 'blur' }],
                    coinDenomination: [{ required: true, message: '请选择面额', trigger: 'change' }],
                    correspondingPoints: [{ required: true, message: '请输入对应积分', trigger: 'blur' }],
                    orderNum: [{ required: true, message: '请输入排序号', trigger: 'blur' }]
                }
            }
        },
        methods: {
            init(row) {
                this.visible = true;
                this.uploadUrl = this.nameUploadImageUrl;
                this.deg = 0;
                this.isUploadImage = false;
                this.$nextTick(() => {
                    if (this.$refs['form']) {
                        this.$refs['form'].clearValidate();
                    }
                    this.form.id = row.id;
                    this.form.deptId = row.deptId;
                    this.form.coinName = row.coinName;
                    this.form.coinDenomination = row.coinDenomination;
                    this.form.correspondingPoints = row.correspondingPoints;
                    this.form.coinImageUrl = row.coinImageUrl || "";
                    this.imageUrl = row.coinImageUrl || "";
                    this.form.orderNum = row.orderNum;
                    this.form.evaluateType = row.evaluateType || "";
                });
            },
            save() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if (!this.form.evaluateType) {
                            this.$commonFn.showTip('请选择五育类型', 3);
                            return;
                        }
                        this.loading = true;
                        this.loadingText = "正在保存...";
                        let data = {
                            id: this.form.id,
                            deptId: this.form.deptId,
                            coinName: this.form.coinName,
                            coinDenomination: this.form.coinDenomination,
                            correspondingPoints: this.form.correspondingPoints,
                            evaluateType: this.form.evaluateType,
                            coinImageUrl: this.form.coinImageUrl,
                            orderNum: this.form.orderNum
                        };
                        this.apiPost(this.schoolCoinUpdateUrl, data).then((res) => {
                            this.loading = false;
                            if (res.status === 200) {
                                this.$commonFn.showTip(res.message, 1);
                                this.visible = false;
                                this.$emit('refresh');
                            } else {
                                this.$commonFn.showTip(res.message, 3);
                            }
                        }, (err) => {
                            console.log(err);
                            this.loading = false;
                        });
                    }
                });
            },
            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                let isJPG = (file.type == 'image/jpeg' || file.type == 'image/png');
                let isLt8M = file.size / 1024 / 1024 < 8;
                if (!isJPG) {
                    this.$message.error('上传校币图片只能是 JPG/PNG 格式!');
                }
                if (!isLt8M) {
                    this.$message.error('上传校币图片大小不能超过 8MB!');
                }
                if (isJPG && isLt8M) {
                    let uploadForm = new FormData();
                    uploadForm.append('file', file);
                    this.$axios.post(this.nameUploadImageUrl, uploadForm).then((res) => {
                        if (res.data.status == 200) {
                            this.form.coinImageUrl = res.data.data.localFile;
                        } else {
                            this.$commonFn.showTip(res.data.message, 3);
                        }
                    }, (err) => {
                        console.log(err);
                        this.$commonFn.showTip('网络繁忙，请稍后重试，响应码(' + err.response.status + ')', 3);
                    });
                } else {
                    return false;
                }
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
    .avatar {
        width: 130px;
        height: 110px;
        display: block;
        object-fit: contain;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/schoolCoin/coinList/Update.vue